/**
 * ブラウザ側で使う UUID 生成。
 *
 * `crypto.randomUUID()` は「安全なコンテキスト (secure context)」限定の API で、
 * https と localhost でしか生えない。この app は iPad などから LAN の IP
 * (`http://192.168.11.50:3000`) でも開くので、そちらでは `crypto.randomUUID` が
 * undefined になり、呼んだ関数がまるごと TypeError で死ぬ (ボタンを押しても
 * 何も起きない、という形で表面化する)。
 *
 * `crypto.getRandomValues()` は安全でないコンテキストでも使えるので、
 * それで RFC 4122 v4 の UUID を組み立てるフォールバックを持たせる。
 * ブラウザ側の ID 生成は必ずこの関数を通すこと (直接 `crypto.randomUUID()` を
 * 呼ぶと LAN 経由のときだけ壊れる)。サーバー側 (API route / lib/db) は Node の
 * crypto がそのまま使えるので対象外。
 */
export function safeRandomUUID(): string {
  const c: Crypto | undefined = globalThis.crypto;
  if (typeof c?.randomUUID === 'function') return c.randomUUID();

  const bytes = new Uint8Array(16);
  if (typeof c?.getRandomValues === 'function') {
    c.getRandomValues(bytes);
  } else {
    // getRandomValues すら無い環境向けの最終手段。衝突耐性は落ちるが、
    // ID が作れずクラッシュするよりはよい。
    for (let i = 0; i < bytes.length; i++) bytes[i] = Math.floor(Math.random() * 256);
  }
  bytes[6] = (bytes[6] & 0x0f) | 0x40; // version 4
  bytes[8] = (bytes[8] & 0x3f) | 0x80; // variant 10x

  const hex = Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
